module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "s-canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "s-canvas",
      "width": _vm.contentWidth,
      "height": _vm.contentHeight
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1faf4b3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VerificationCode.vue
// module id = 420
// module chunks = 0